import { Fragment } from "react";
import { GrDivider, GrIcon, GrStack, GrTypography, palette } from "@jnpmedi/grebob";
import { AuditTrailRow } from "@newComponents/common/AuditTrailRow";
import { InformationGuide } from "@newComponents/layout/InformationGuide";
import { resolveDocumentSignStatusBulletIconColor } from "@newLibs/converting";
import { MvnMessage } from "@newLibs/utils";
import { DocumentSign } from "@maven-rest/docs/DocumentSign.dto";

export enum AuditTrailViewType {
  Detail = "DETAIL",
  LeftSide = "LEFT_SIDE",
}
interface SignerAuditTrailProps {
  documentSign: DocumentSign;
  viewType?: AuditTrailViewType;
}

export function SignerAuditTrail({ documentSign, viewType = AuditTrailViewType.Detail }: SignerAuditTrailProps) {
  const isLeftSizeViewMode = viewType === AuditTrailViewType.LeftSide;

  return (
    <GrStack
      style={{
        padding: isLeftSizeViewMode ? "0px 16px" : "16px",
        backgroundColor: palette["white"],
        width: "100%",
        borderRadius: isLeftSizeViewMode ? undefined : "6px",
        marginTop: isLeftSizeViewMode ? undefined : "8px",
      }}
      flexDirection="column"
      gap={isLeftSizeViewMode ? 12 : 16}
    >
      <GrTypography type={isLeftSizeViewMode ? "Content.Subtitle02" : "Content.Title03"} color="grey080">
        {MvnMessage("Audit Trail")}
      </GrTypography>

      <GrStack flexDirection="column">
        {!documentSign.histories.length && <InformationGuide style={{ height: "400px" }} title="No History" description="" />}

        {!!documentSign.histories.length &&
          documentSign.histories.map((history, index) => (
            <Fragment key={String(history.id || index)}>
              {!!index && <GrDivider spacing={8} />}
              <GrStack gap={4}>
                <GrIcon
                  style={{ marginTop: "2px" }}
                  type="point-filled"
                  size={16}
                  color={resolveDocumentSignStatusBulletIconColor(history)}
                />
                <AuditTrailRow key={history.type} history={history} viewType={viewType} />
              </GrStack>
            </Fragment>
          ))}
      </GrStack>
    </GrStack>
  );
}
